import React from "react";
import About from "../About";
import Section from "../Section";

export default function AboutSection() {
  return <>
    <Section index="0" letter="a" content={<About/>}></Section>
  </>
}